/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define('collaboration/glass/utils/GlassUtil',[], function () {
	// SUPPORTED FEATURES
	// ------------------
	// From perspective:
	// com.ibm.ca.collaboration.share (Share)
	// +-- com.ibm.bi.dashboard.exportPdf (Export to PDF)
	// +-- com.ibm.ca.collaboration.sendCurrent (Send)
	// |   +-- com.ibm.ca.collaboration.emailCurrent (Email)
	// |   |   +-- com.ibm.ca.collaboration.emailLinkCurrent (Include link)
	// |   |   +-- com.ibm.ca.collaboration.emailImageCurrent (Include image)
	// |   |   +-- com.ibm.ca.collaboration.emailReportCurrent (Attach report)
	// |   +-- com.ibm.ca.collaboration.platformsCurrent (Collaboration platforms)
	// |       +-- com.ibm.ca.collaboration.platformsLinkCurrent (Include link)
	// |       +-- com.ibm.ca.collaboration.platformsImageCurrent (Include image)
	// +-- com.ibm.bi.glass.common.operations.shareCurrent (Link)
	// +-- com.ibm.bi.glass.common.operations.embedCurrent (Embed)
	//
	// From context menu:
	// com.ibm.ca.collaboration.shareContextual (Share)
	// +-- com.ibm.ca.collaboration.sendContextual (Send)
	// |   +-- com.ibm.ca.collaboration.emailContextual (Email)
	// |   |   +-- com.ibm.ca.collaboration.emailLinkContextual (Include link)
	// |   |   +-- com.ibm.ca.collaboration.emailReportContextual (Attach report output)
	// |   +-- com.ibm.ca.collaboration.platformsContextual (Collaboration platforms)
	// |       +-- com.ibm.ca.collaboration.platformsLinkContextual (Include link)
	// +-- com.ibm.bi.glass.common.shareContextual (Link)
	// +-- com.ibm.bi.glass.common.embedContextual (Embed)

	// perspective menu items that are defined in perspectives/common/collaboration.json
	var perspective = Object.freeze({
		current: Object.freeze({
			SEND: 'com.ibm.ca.collaboration.sendCurrent',
			LINK: 'com.ibm.bi.glass.common.operations.shareCurrent',
			EMBED: 'com.ibm.bi.glass.common.operations.embedCurrent',
			EXPORT: 'com.ibm.bi.dashboard.exportPdf',
			EMAIL: 'com.ibm.ca.collaboration.emailCurrent',
			EMAIL_LINK: 'com.ibm.ca.collaboration.emailLinkCurrent',
			EMAIL_IMAGE: 'com.ibm.ca.collaboration.emailImageCurrent',
			EMAIL_REPORT_CURRENT: 'com.ibm.ca.collaboration.emailReportCurrent',
			PLATFORMS_LINK: 'com.ibm.ca.collaboration.platformsLinkCurrent',
			PLATFORMS_IMAGE: 'com.ibm.ca.collaboration.platformsImageCurrent'
		}),
		contextual: Object.freeze({
			SEND: 'com.ibm.ca.collaboration.sendContextual',
			LINK: 'com.ibm.bi.glass.common.shareContextual',
			EMBED: 'com.ibm.bi.glass.common.embedContextual',
			EMAIL: 'com.ibm.ca.collaboration.emailContextual',
			EMAIL_LINK: 'com.ibm.ca.collaboration.emailLinkContextual',
			EMAIL_IMAGE: 'com.ibm.ca.collaboration.emailImageContextual',
			EMAIL_REPORT_CONTEXTUAL: 'com.ibm.ca.collaboration.emailReportContextual',
			PLATFORMS_LINK: 'com.ibm.ca.collaboration.platformsLinkContextual'
		})
	});

	var feature = Object.freeze({
		SEND: 'send',
		LINK: 'link',
		EMBED: 'embed',
		EXPORT: 'export',
		EMAIL: 'email',
		EMAIL_LINK: 'emailLink',
		EMAIL_IMAGE: 'emailImage',
		EMAIL_REPORT_CURRENT: 'emailReportCurrent',
		EMAIL_REPORT_CONTEXTUAL: 'emailReportContextual',
		PLATFORMS_LINK: 'platformsLink',
		PLATFORMS_IMAGE: 'platformsImage'
	});

	function _currentMap() {
		var map = {};
		map[perspective.current.SEND] = feature.SEND;
		map[perspective.current.LINK] = feature.LINK;
		map[perspective.current.EMBED] = feature.EMBED;
		map[perspective.current.EXPORT] = feature.EXPORT;
		map[perspective.current.EMAIL] = feature.EMAIL;
		map[perspective.current.EMAIL_LINK] = feature.EMAIL_LINK;
		map[perspective.current.EMAIL_IMAGE] = feature.EMAIL_IMAGE;
		map[perspective.current.EMAIL_REPORT_CURRENT] = feature.EMAIL_REPORT_CURRENT;
		map[perspective.current.PLATFORMS_LINK] = feature.PLATFORMS_LINK;
		map[perspective.current.PLATFORMS_IMAGE] = feature.PLATFORMS_IMAGE;
		return Object.freeze(map);
	}

	function _contextualMap() {
		var map = {};
		map[perspective.contextual.SEND] = feature.SEND;
		map[perspective.contextual.LINK] = feature.LINK;
		map[perspective.contextual.EMBED] = feature.EMBED;
		map[perspective.contextual.EMAIL] = feature.EMAIL;
		map[perspective.contextual.EMAIL_LINK] = feature.EMAIL_LINK;
		map[perspective.contextual.EMAIL_IMAGE] = feature.EMAIL_IMAGE;
		map[perspective.contextual.EMAIL_REPORT_CONTEXTUAL] = feature.EMAIL_REPORT_CONTEXTUAL;
		map[perspective.contextual.PLATFORMS_LINK] = feature.PLATFORMS_LINK;
		return Object.freeze(map);
	}

	var current = _currentMap();
	var contextual = _contextualMap();

	var itemsToFeatures = function itemsToFeatures(map, items, features) {
		features = features || [];

		items.forEach(function (item) {
			var mapped = map[item.id];

			mapped && features.push(mapped);
			item.items && itemsToFeatures(map, item.items, features);
		});

		return features;
	};

	var featuresForPerspective = function featuresForPerspective(items) {
		return itemsToFeatures(current, items);
	};
	var featuresForContextual = function featuresForContextual(items) {
		return itemsToFeatures(contextual, items);
	};

	return {
		perspective: perspective,
		feature: feature,
		featuresForPerspective: featuresForPerspective,
		featuresForContextual: featuresForContextual
	};
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

